import PubSub from "underpub-js";
import Parsley from "parsleyjs";

var FormWithBgImage = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-FormWithBgImage',
	};

	$.extend(true, this.options, options);

};

FormWithBgImage.prototype.init = function() {

	var self = this;

	// by default formie provides front-end validation, but the parsley code below can be used
	// if custom validation is necessary (or if not using formie)

	/*

	this.parsleyValidator = this.options.$el.find('form').parsley({

		errorsContainer: function(parsleyField) {

			var $inputField = parsleyField.$element;
			var fieldType = $inputField.prop("type");

			if (fieldType == 'radio' || fieldType == 'checkbox')
			{
				return $inputField.parent().parent();
			}
			else
			{
				return parsleyField;
			}

		}

	});

	*/

	var $form = this.options.$el.find("form");

	// Submit tracking events when the form is submitted.
	$form.on('onAfterFormieSubmit', function(e) {

		// only fire these if the relevant tracking scripts have been set up in SEOmatic
		// if(typeof gtag !== "undefined"){
		// 	gtag('event', 'generate_lead', {
    //             'event_category' : 'engagement'
    //         });
		// }
		//
		// if(typeof fbq !== "undefined"){
		// 	fbq('track', 'Lead');
		// }

	});

};

export default FormWithBgImage;
